import type { SVGProps } from 'react';
const SvgBedSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 6c.553 0 1 .447 1 1v8h7v-5c0-.553.447-1 1-1h7a3 3 0 0 1 3 3v7a.999.999 0 1 1-2 0v-1H5v1a.999.999 0 1 1-2 0V7c0-.553.447-1 1-1m4.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
    />
  </svg>
);
export default SvgBedSolid;
